module.exports = __webpack_public_path__ + "img/pr-3.9a213db8.png";